import { render, staticRenderFns } from "./MenuDossierReason.vue?vue&type=template&id=3c696a98&"
import script from "./MenuDossierReason.vue?vue&type=script&lang=js&"
export * from "./MenuDossierReason.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports